export default __webpack_public_path__ + "static/media/24.6e235d26.png";